// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3881d243","178":"186234ab","270":"6d398a12","425":"580126f3","426":"7525b9f8","486":"fa9e90d0","638":"99ed1a7a","910":"beb2cf54","925":"05d63dd3"}[chunkId] + ".chunk.js";
};